import React from 'react'
import { Modal, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DeleteConfirmationModalProps } from '../types/view_product';

const DeleteConfirmationModal = ({ showDeleteModal, handleCloseDeleteModal, handleDelete, deleting }: DeleteConfirmationModalProps) => {
    const { t } = useTranslation();
  return (
    <div>
        <Modal show={showDeleteModal} className="logoutModal" onHide={handleCloseDeleteModal} centered>
                <Modal.Header closeButton>
                  <Modal.Title>{t("commonHeader.deleteConfirmation")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {t("commonHeader.areYouSureDelete")}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseDeleteModal}>
                    {t("commonHeader.cancel")}
                  </Button>
                  <Button
                        variant="danger"
                        onClick={handleDelete}
                        disabled={deleting} // Disable the button while deleting
                      >
                        {deleting ? (
                          <Spinner animation="border" size="sm" /> // Show spinner while deleting
                        ) : (
                          t("commonHeader.delete")
                        )}
                      </Button>
                </Modal.Footer>
              </Modal>
    </div>
  )
}

export default DeleteConfirmationModal